export function isObjEmpty(obj: any) {
  return !obj || Object.keys(obj).length === 0;
}
